import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { AutomationStep } from "@/types/Automation";
import type { StepNodeData } from "../types";

export function ManychatCreateSubscriberFields({
  step,
  onManychatTagIdsChange,
}: {
  step: AutomationStep;
  onManychatTagIdsChange: StepNodeData["onManychatTagIdsChange"];
}) {
  const tagIds = step.data?.tagIds ?? [];

  return (
    <div className="p-4 space-y-3 nodrag" onPointerDownCapture={(e) => e.stopPropagation()}>
      <p className="text-xs text-muted-foreground">
        Updates the lead&apos;s Manychat subscriber using their profile data. Requires a Manychat subscriber ID on the lead.
      </p>
      <div className="space-y-2">
        <Label className="text-xs text-amber-800">Tag IDs (optional)</Label>
        <p className="text-xs text-muted-foreground">Manychat tag ids as plain text (one per row).</p>
        <div className="space-y-2">
          {tagIds.map((tagId, ti) => (
            <div key={ti} className="flex gap-2">
              <Input
                value={tagId}
                onChange={(e) => {
                  const next = [...tagIds];
                  next[ti] = e.target.value;
                  onManychatTagIdsChange({ stepId: step.id, tagIds: next });
                }}
                placeholder="Tag ID"
                className="text-sm"
              />
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="shrink-0 h-8 w-8"
                onClick={() => {
                  const next = tagIds.filter((_, i) => i !== ti);
                  onManychatTagIdsChange({ stepId: step.id, tagIds: next });
                }}
              >
                <Trash2 className="h-3 w-3" />
              </Button>
            </div>
          ))}
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="w-full text-sm"
            onClick={() =>
              onManychatTagIdsChange({
                stepId: step.id,
                tagIds: [...tagIds, ""],
              })
            }
          >
            <Plus className="h-4 w-4 mr-1" />
            Add tag
          </Button>
        </div>
      </div>
    </div>
  );
}
